<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">직원관리</span>
            <span class="txt">현재 근무중인 직원을 확인할 수 있으며, 직원 설정이 가능합니다.</span>
        </div>

        <div class="employee-top-info">
            <ul class="select-photo-list">
                <li>
                    <a href="#">
                        <img
                            :src="employeeInfo.imageUrl === null ? '/img/temp/no_photo.jpg' : employeeInfo.imageUrl"
                            alt=""
                            @error="imageUrlAlt"
                        />
                        <span class="name">{{ staffTopInfo.name }}</span>
                        <span class="tel">{{ staffTopInfo.phone | phoneNumberFilter }}</span>
                        <span class="type">{{ staffTopInfo.roleName }}</span>
                        <span class="detail">{{ staffTopInfo.staffTeams }}</span>
                    </a>
                </li>
            </ul>
        </div>

        <div class="com-tab">
            <button @click="onClickRouter('/madmin/mypage/info')">기본정보</button>
            <button class="on">근무시간</button>
        </div>

        <div class="sub-title-content">
            <span class="title">근무시간설정</span>
            <p class="info-txt">
                규칙적인 근무 가능시간 및 휴식시간을 설정합니다. 설정한 시간은 회원예약 어플리케이션에 적용됩니다.
                <br />
                휴식시간 설정 시, 근무시간에서 휴식시간을 제외하고 남은 시간만 예약 가능한 시간으로 노출됩니다.
            </p>
        </div>

        <div class="com-week-table">
            <table class="com-table">
                <colgroup>
                    <col style="width: 95px" />
                    <col style="width: 615px" />
                    <col style="width: 615px" />
                    <col style="width: 95px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>요일</th>
                        <th>근무시간</th>
                        <th>휴식시간</th>
                        <th>휴식없음</th>
                        <th>휴무일</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in week" :key="index">
                        <td>{{ item }}</td>
                        <td>
                            <div class="flex center">
                                <time-select
                                    :disabled="data[`week${index + 1}Yn`]"
                                    :step-minutes="30"
                                    :time.sync="data[`week${index + 1}WorkStartTime`]"
                                />
                                <div class="com-dash"><span class="dash">~</span></div>
                                <time-select
                                    :disabled="data[`week${index + 1}Yn`]"
                                    :step-minutes="30"
                                    :time.sync="data[`week${index + 1}WorkEndTime`]"
                                />
                            </div>
                        </td>
                        <td>
                            <div class="flex center">
                                <time-select
                                    :disabled="data[`week${index + 1}Yn`] || data[`week${index + 1}RestYn`]"
                                    :step-minutes="30"
                                    :time.sync="data[`week${index + 1}RestStartTime`]"
                                />
                                <div class="com-dash"><span class="dash">~</span></div>
                                <time-select
                                    :disabled="data[`week${index + 1}Yn`] || data[`week${index + 1}RestYn`]"
                                    :step-minutes="30"
                                    :time.sync="data[`week${index + 1}RestEndTime`]"
                                />
                            </div>
                        </td>
                        <td>
                            <div class="com-check">
                                <input
                                    :id="`check-week-rest${index + 1}`"
                                    v-model="data[`week${index + 1}RestYn`]"
                                    name="check-week-rest"
                                    type="checkbox"
                                    @click="noRestTime(index)"
                                />
                                <label :for="`check-week-rest${index + 1}`"></label>
                            </div>
                        </td>
                        <td>
                            <div class="com-check">
                                <input
                                    :id="`check-week-${index + 1}`"
                                    v-model="data[`week${index + 1}Yn`]"
                                    name="check-week"
                                    type="checkbox"
                                />
                                <label :for="`check-week-${index + 1}`"></label>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <!--                <tbody>-->
                <!--                    <tr>-->
                <!--                        <td>월</td>-->
                <!--                        <td>-->
                <!--                            <time-select @update:time="(val) => { workInfo.week1WorkStartTime = val }" :disabled="workInfo.week1Yn" -->
                <!--                                :time="dateFormat(workInfo.week1WorkStartTime)"></time-select>-->
                <!--                            <span class="dash">~</span>-->
                <!--                            <time-select @update:time="val => workInfo.week1WorkEndTime =val" :disabled="workInfo.week1Yn" -->
                <!--                                :time="dateFormat(workInfo.week1WorkEndTime)"></time-select>-->
                <!--                        </td>-->
                <!--                        <td>-->
                <!--                            <time-select @update:time="val => workInfo.week1RestStartTime =val" :disabled="workInfo.week1Yn" -->
                <!--                                :time="dateFormat(workInfo.week1RestStartTime)"></time-select>-->
                <!--                            <span class="dash">~</span>-->
                <!--                            <time-select @update:time="val => workInfo.week1RestEndTime=val" :disabled="workInfo.week1Yn" -->
                <!--                                :time="dateFormat(workInfo.week1RestEndTime)"></time-select>-->
                <!--                        </td>-->
                <!--                        <td>-->
                <!--                            <div class="com-check">-->
                <!--                                <input type="checkbox" name="check-week" id="check-week-1" v-model="workInfo.week1Yn">-->
                <!--                                <label for="check-week-1"></label>-->
                <!--                            </div>-->
                <!--                        </td>-->
                <!--                    </tr>-->
                <!--                    <tr>-->
                <!--                        <td>화</td>-->
                <!--                        <td>-->
                <!--                            <time-select @update:time="val => workInfo.week2WorkStartTime = val" :disabled="workInfo.week2Yn" -->
                <!--                                :time="dateFormat(workInfo.week2WorkStartTime)"></time-select>-->
                <!--                            <span class="dash">~</span>-->
                <!--                            <time-select @update:time="val => workInfo.week2WorkEndTime = val" :disabled="workInfo.week2Yn" -->
                <!--                                :time="dateFormat(workInfo.week2WorkEndTime)"></time-select>-->
                <!--                        </td>-->
                <!--                        <td>-->
                <!--                            <time-select @update:time="val => workInfo.week2RestStartTime = val" :disabled="workInfo.week2Yn" -->
                <!--                                :time="dateFormat(workInfo.week2RestStartTime)"></time-select>-->
                <!--                            <span class="dash">~</span>-->
                <!--                            <time-select @update:time="val => workInfo.week2RestEndTime = val" :disabled="workInfo.week2Yn" -->
                <!--                                :time="dateFormat(workInfo.week2RestEndTime)"></time-select>-->
                <!--                        </td>-->
                <!--                        <td>-->
                <!--                            <div class="com-check">-->
                <!--                                <input type="checkbox" name="check-week" id="check-week-2" v-model="workInfo.week2Yn">-->
                <!--                                <label for="check-week-2"></label>-->
                <!--                            </div>-->
                <!--                        </td>-->
                <!--                    </tr>-->
                <!--                    <tr>-->
                <!--                        <td>수</td>-->
                <!--                        <td>-->
                <!--                            <time-select @update:time="val => workInfo.week3WorkStartTime = val" :disabled="workInfo.week3Yn" -->
                <!--                                :time="dateFormat(workInfo.week3WorkStartTime)"></time-select>-->
                <!--                            <span class="dash">~</span>-->
                <!--                            <time-select @update:time="val => workInfo.week3WorkEndTime = val" :disabled="workInfo.week3Yn" -->
                <!--                                :time="dateFormat(workInfo.week3WorkEndTime)"></time-select>-->
                <!--                        </td>-->
                <!--                        <td>-->
                <!--                            <time-select @update:time="val => workInfo.week3RestStartTime = val" :disabled="workInfo.week3Yn" -->
                <!--                                :time="dateFormat(workInfo.week3RestStartTime)"></time-select>-->
                <!--                            <span class="dash">~</span>-->
                <!--                            <time-select @update:time="val => workInfo.week3RestEndTime = val" :disabled="workInfo.week3Yn" -->
                <!--                                :time="dateFormat(workInfo.week3RestEndTime)"></time-select>-->
                <!--                        </td>-->
                <!--                        <td>-->
                <!--                            <div class="com-check">-->
                <!--                                <input type="checkbox" name="check-week" id="check-week-3" v-model="workInfo.week3Yn">-->
                <!--                                <label for="check-week-3"></label>-->
                <!--                            </div>-->
                <!--                        </td>-->
                <!--                    </tr>-->
                <!--                    <tr>-->
                <!--                        <td>목</td>-->
                <!--                        <td>-->
                <!--                            <time-select @update:time="val => workInfo.week4WorkStartTime = val" :disabled="workInfo.week4Yn" -->
                <!--                                :time="dateFormat(workInfo.week4WorkStartTime)"></time-select>-->
                <!--                            <span class="dash">~</span>-->
                <!--                            <time-select @update:time="val => workInfo.week4WorkEndTime = val" :disabled="workInfo.week4Yn" -->
                <!--                                :time="dateFormat(workInfo.week4WorkEndTime)"></time-select>-->
                <!--                        </td>-->
                <!--                        <td>-->
                <!--                            <time-select @update:time="val => workInfo.week4RestStartTime = val" :disabled="workInfo.week4Yn" -->
                <!--                                :time="dateFormat(workInfo.week4RestStartTime)"></time-select>-->
                <!--                            <span class="dash">~</span>-->
                <!--                            <time-select @update:time="val => workInfo.week4RestEndTime = val" :disabled="workInfo.week4Yn" -->
                <!--                                :time="dateFormat(workInfo.week4RestEndTime)"></time-select>-->
                <!--                        </td>-->
                <!--                        <td>-->
                <!--                            <div class="com-check">-->
                <!--                                <input type="checkbox" name="check-week" id="check-week-4" v-model="workInfo.week4Yn">-->
                <!--                                <label for="check-week-4"></label>-->
                <!--                            </div>-->
                <!--                        </td>-->
                <!--                    </tr>-->
                <!--                    <tr>-->
                <!--                        <td>금</td>-->
                <!--                        <td>-->
                <!--                            <time-select @update:time="val => workInfo.week5WorkStartTime = val" :disabled="workInfo.week5Yn" -->
                <!--                                :time="dateFormat(workInfo.week5WorkStartTime)"></time-select>-->
                <!--                            <span class="dash">~</span>-->
                <!--                            <time-select @update:time="val => workInfo.week5WorkEndTime = val" :disabled="workInfo.week5Yn" -->
                <!--                                :time="dateFormat(workInfo.week5WorkEndTime)"></time-select>-->
                <!--                        </td>-->
                <!--                        <td>-->
                <!--                            <time-select @update:time="val => workInfo.week5RestStartTime = val" :disabled="workInfo.week5Yn" -->
                <!--                                :time="dateFormat(workInfo.week5RestStartTime)"></time-select>-->
                <!--                            <span class="dash">~</span>-->
                <!--                            <time-select @update:time="val => workInfo.week5RestEndTime = val" :disabled="workInfo.week5Yn" -->
                <!--                                :time="dateFormat(workInfo.week5RestEndTime)"></time-select>-->
                <!--                        </td>-->
                <!--                        <td>-->
                <!--                            <div class="com-check">-->
                <!--                                <input type="checkbox" name="check-week" id="check-week-5" v-model="workInfo.week5Yn">-->
                <!--                                <label for="check-week-5"></label>-->
                <!--                            </div>-->
                <!--                        </td>-->
                <!--                    </tr>-->
                <!--                    <tr>-->
                <!--                        <td>토</td>-->
                <!--                        <td>-->
                <!--                            <time-select @update:time="val => workInfo.week6WorkStartTime = val" :disabled="workInfo.week6Yn" -->
                <!--                                :time="dateFormat(workInfo.week6WorkStartTime)"></time-select>-->
                <!--                            <span class="dash">~</span>-->
                <!--                            <time-select @update:time="val => workInfo.week6WorkEndTime = val" :disabled="workInfo.week6Yn" -->
                <!--                                :time="dateFormat(workInfo.week6WorkEndTime)"></time-select>-->
                <!--                        </td>-->
                <!--                        <td>-->
                <!--                            <time-select @update:time="val => workInfo.week6RestStartTime = val" :disabled="workInfo.week6Yn" -->
                <!--                                :time="dateFormat(workInfo.week6RestStartTime)"></time-select>-->
                <!--                            <span class="dash">~</span>-->
                <!--                            <time-select @update:time="val => workInfo.week6RestEndTime = val" :disabled="workInfo.week6Yn" -->
                <!--                                :time="dateFormat(workInfo.week6RestEndTime)"></time-select>-->
                <!--                        </td>-->
                <!--                        <td>-->
                <!--                            <div class="com-check">-->
                <!--                                <input type="checkbox" name="check-week" id="check-week-6" v-model="workInfo.week6Yn">-->
                <!--                                <label for="check-week-6"></label>-->
                <!--                            </div>-->
                <!--                        </td>-->
                <!--                    </tr>-->
                <!--                    <tr>-->
                <!--                        <td>일</td>-->
                <!--                        <td>-->
                <!--                            <time-select @update:tiem="val =>workInfo.week7WorkStartTime = val" :disabled="workInfo.week7Yn" -->
                <!--                                :time="dateFormat(workInfo.week7WorkStartTime)"></time-select>-->
                <!--                            <span class="dash">~</span>-->
                <!--                            <time-select @update:time="val => workInfo.week7WorkEndTime = val" :disabled="workInfo.week7Yn" -->
                <!--                                :time="dateFormat(workInfo.week7WorkEndTime)"></time-select>-->
                <!--                        </td>-->
                <!--                        <td>-->
                <!--                            <time-select @update:time="val => workInfo.week7RestStartTime = val" :disabled="workInfo.week7Yn" -->
                <!--                                :time="dateFormat(workInfo.week7RestStartTime)"></time-select>-->
                <!--                            <span class="dash">~</span>-->
                <!--                            <time-select @update:time="val => workInfo.week7RestEndTime = val" :disabled="workInfo.week7Yn" -->
                <!--                                :time="dateFormat(workInfo.week7RestEndTime)"></time-select>-->
                <!--                        </td>-->
                <!--                        <td>-->
                <!--                            <div class="com-check">-->
                <!--                                <input type="checkbox" name="check-week" id="check-week-7" v-model="workInfo.week7Yn">-->
                <!--                                <label for="check-week-7"></label>-->
                <!--                            </div>-->
                <!--                        </td>-->
                <!--                    </tr>-->
                <!--                </tbody>-->
            </table>
            <div class="check-line">
                <div class="com-check">
                    <input id="day-check" v-model="workInfo.hollydayOffYn" name="day-check" type="checkbox" />
                    <label for="day-check">국가 공휴일을 휴무일로 지정합니다.</label>
                </div>
            </div>
        </div>

        <div class="holiday-setting-content">
            <div class="left-box">
                <div class="title-area">
                    <span class="tit">휴가설정</span>
                    <span class="txt">
                        휴가 및 연차와 반차, 불가피하게 예약을 받지 못하는 일부 시간 및 기간을 설정합니다.
                        <br />
                        설정한 시간은 회원예약 어플리케이션에 적용되어 노출되지 않으며 예약이 불가합니다.
                    </span>
                </div>
                <div class="calendar-area">
                    <b-calendar
                        :date-info-fn="dateClass"
                        locale="kr"
                        @context="(c) => (selectedMonth = c.activeDate)"
                    ></b-calendar>
                </div>
            </div>
            <div class="right-box">
                <div class="top-area">
                    <span class="year">&lt; {{ year }} &gt;</span>
                    <div class="right-btn">
                        <button v-if="!isEditing" class="com-btn white" type="button" @click="isEditing = true">
                            수정
                        </button>
                        <button v-if="isEditing" class="com-btn white" type="button" @click="isEditing = false">
                            완료
                        </button>
                        <button class="com-btn" type="button" @click="addHoliday">+ 추가</button>
                    </div>
                </div>
                <div class="com-scroll-table com-scroll-y">
                    <table class="com-table no-border">
                        <colgroup>
                            <col style="width: 220px" />
                            <col style="width: 510px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>일정</th>
                                <th>시간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- <tr>
                            <td>
                                <span class="calendar-time day-time">
                                    <span class="calendar-day">2019-11-04</span>
                                    <span class="dash">:</span>
                                    <span class="end">12 : 30 PM</span>
                                </span>
                            </td>
                            <td>
                                <span class="calendar-time day-time">
                                    <span class="calendar-day">2019-11-04</span>
                                    <span class="dash">:</span>
                                    <span class="end">12 : 30 PM</span>
                                </span>
                            </td>
                        </tr>
                        <!- 수정 일시 -->
                            <!-- <tr class="modify">
                            <td>
                                <span class="calendar-time day-time" @click="holidayPop = true">
                                    <span class="calendar-day">2019-11-04</span>
                                    <span class="dash">:</span>
                                    <span class="end">12 : 30 PM</span>
                                </span>
                            </td>
                            <td>
                                <span class="calendar-time day-time" @click="holidayPop = false">
                                    <span class="calendar-day">2019-11-04</span>
                                    <span class="dash">:</span>
                                    <span class="end">12 : 30 PM</span>
                                </span>
                                <button class="com-btn red">삭제</button>
                            </td>
                        </tr>
                        <-- 수정 일시 끝 -->
                            <!-- 반복문 null 값 제외 -->
                            <tr v-for="(h, index) in holidays" :key="index" :class="{ modify: isEditing }">
                                <td>
                                    <span class="calendar-day" @click="editHoliday(h)" v-html="h.calenderDate">
                                        {{ h.calenderDate }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="h.hollydayFullYn" class="calendar-time" @click="editHoliday(h)">
                                        <span class="start">하루종일</span>
                                    </span>
                                    <span v-else class="calendar-time" @click="editHoliday(h)">
                                        <span class="start">{{ $moment(h.startTime, 'HH:mm:ss').format('LT') }}</span>
                                        <div class="com-dash"><span class="dash">~</span></div>
                                        <span class="end">{{ $moment(h.endTime, 'HH:mm:ss').format('LT') }}</span>
                                    </span>
                                    <button
                                        v-if="isEditing"
                                        class="com-btn red"
                                        type="button"
                                        @click="removeHoliday(h)"
                                    >
                                        삭제
                                    </button>
                                </td>
                            </tr>
                            <!-- 반복문 끝 -->
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="bottom-btn">
            <button class="com-btn">취소</button>
            <button class="com-btn blue" @click="save">저장</button>
        </div>

        <!-- 휴가설정 팝업 -->
        <div v-show="holidayPop" class="layer-pop square-type">
            <div class="view-content w655">
                <button class="close" @click="holidayPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y h550">
                    <span class="sub-title">휴가설정</span>
                    <table class="com-table left no-border">
                        <colgroup>
                            <col style="width: 100%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <td>
                                    <span class="top-tit">날짜 선택</span>
                                    <div class="input-line">
                                        <div class="com-calendar-wrap">
                                            <single-calendar
                                                :date="selectedHoliday.calenderStartDate"
                                                class="w220"
                                                @update="
                                                    (v) => {
                                                        selectedHoliday.calenderStartDate = v;
                                                        selectedHoliday.calenderEndDate = v;
                                                    }
                                                "
                                            />
                                            <div class="com-dash"><span class="dash">~</span></div>
                                            <single-calendar
                                                :date="selectedHoliday.calenderEndDate"
                                                class="w220"
                                                @update="(v) => (selectedHoliday.calenderEndDate = v)"
                                            />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span class="top-tit">시간 선택</span>
                                    <div class="input-line">
                                        <div class="com-calendar-wrap">
                                            <time-select
                                                :disabled="selectedHoliday.hollydayFullYn"
                                                :step-minutes="30"
                                                :time.sync="selectedHoliday.startTime"
                                            />
                                            <div class="com-dash"><span class="dash">~</span></div>
                                            <time-select
                                                :disabled="selectedHoliday.hollydayFullYn"
                                                :step-minutes="30"
                                                :time.sync="selectedHoliday.endTime"
                                            />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="check-line">
                        <div class="com-check">
                            <input
                                id="check-hollyday-full"
                                v-model="selectedHoliday.hollydayFullYn"
                                name="check-hollyday-full"
                                type="checkbox"
                            />
                            <label for="check-hollyday-full">하루종일</label>
                        </div>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="holidayPop = false">취소</button>
                        <button class="com-btn blue" @click="saveHoliday">저장</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';

export default {
    name: 'MypageTime',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        uId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
    },
    data() {
        return {
            loginCenterId: '',
            centerStaffId: '',
            holidayPop: false, // 휴일설정 팝업
            isEditing: false,
            week: ['월', '화', '수', '목', '금', '토', '일'],
            data: {
                centerId: 0,
                centerStaffId: 0,
                hollydayOffYn: true,
                week1Yn: false,
                week1RestYn: true,
                week1WorkStartTime: '07:00:00',
                week1WorkEndTime: '22:00:00',
                week1RestStartTime: '12:00:00',
                week1RestEndTime: '13:00:00',
                week2Yn: false,
                week2RestYn: true,
                week2WorkStartTime: '07:00:00',
                week2WorkEndTime: '22:00:00',
                week2RestStartTime: '12:00:00',
                week2RestEndTime: '13:00:00',
                week3Yn: false,
                week3RestYn: true,
                week3WorkStartTime: '07:00:00',
                week3WorkEndTime: '22:00:00',
                week3RestStartTime: '12:00:00',
                week3RestEndTime: '13:00:00',
                week4Yn: false,
                week4RestYn: true,
                week4WorkStartTime: '07:00:00',
                week4WorkEndTime: '22:00:00',
                week4RestStartTime: '12:00:00',
                week4RestEndTime: '13:00:00',
                week5Yn: false,
                week5RestYn: true,
                week5WorkStartTime: '07:00:00',
                week5WorkEndTime: '22:00:00',
                week5RestStartTime: '12:00:00',
                week5RestEndTime: '13:00:00',
                week6Yn: false,
                week6RestYn: true,
                week6WorkStartTime: '07:00:00',
                week6WorkEndTime: '22:00:00',
                week6RestStartTime: '12:00:00',
                week6RestEndTime: '13:00:00',
                week7Yn: false,
                week7RestYn: true,
                week7WorkStartTime: '07:00:00',
                week7WorkEndTime: '22:00:00',
                week7RestStartTime: '12:00:00',
                week7RestEndTime: '13:00:00',
                centerStaffCalendars: [
                    // {
                    //     centerId: 0,
                    //     centerStaffId: 0,
                    //     calenderDate: this.$moment().format('YYYY-MM-DD'),
                    //     hollydayType: 'P',
                    //     hollydayFullYn: false,
                    //     startTime: '09:00:00',
                    //     endTime: '18:00:00',
                    //     memo: 'string',
                    // },
                ],
            },
            codes: {},
            selectedMonth: new Date(),
            selectedHoliday: {},
            holidays: '',

            monday: '', // 월요일
            tuesday: '', // 화요일
            wednesday: '', // 수요일
            thursday: '', // 목요일
            friday: '', // 금요일
            saturday: '', // 토요일
            sunday: '', // 일요일
            rows: [{}], // 기본 테이블 값
            centerId: '',
            // centerStaffId: JSON.parse(localStorage.getItem('userInfo')).uid,
            workInfo: {},
            time: {},
            staffCalender: '', // 스태프 휴가 캘린더
            staffHolidayCalender: false, // 국가공휴일 여부 지정
            holidayStartDateTime: {
                hDateTime: '',
                hDate: '',
                hTime: '',
            },
            holidayEndDateTime: {
                hDateTime: '',
                hDate: '',
                hTime: '',
            },
            staff: {}, // 휴가끝시간
            name: '',
            img: '',
            position: '',
            staffCalendars: [], // 스태프캘린더 리스트
            calenderDate: '',
            classmodify: false, // 클래스변경을 위한 데이터
            holidayAllDay: false, // 팝업시 휴가 하루종일 체크여부
            year: moment().format('YYYY'), // 년도

            employeeInfo: {},
            staffTopInfo: {
                // 상단에 노출되는 직원 정보 UI
                name: '',
                phone: '',
                roleName: '',
                staffTeams: '',
            },
        };
    },
    async beforeMount() {
        this.loginCenterId = parseInt(this.cId);
        this.centerStaffId = parseInt(this.uId);
        this.load();
        this.loadHoliday();
    },
    mounted() {
        this.fetchCenterStaffDetail();
    },
    methods: {
        load() {
            this.isLoading = true;
            api.get(
                `/admin/api/center/${this.loginCenterId}/staff/${
                    this.centerStaffId
                }/work-schedule/${this.selectedMonth.getFullYear()}`
            )
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data;
                    this.data.isNew = false;
                    this.data.centerStaffCalendars.forEach((o, i) => (o.index = i));
                    Object.keys(this.data).forEach((k) => {
                        if (k.search(/time$/i) >= 0) {
                            this.data[k] = this.data[k] ? this.data[k].replace('+00', '') : this.data[k];
                        }
                    });
                })
                .catch((res) => {
                    this.isLoading = false;
                    this.data.isNew = true;
                    // if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    // console.error(res);
                });
        },
        // 휴가 조회
        async loadHoliday() {
            try {
                const { data } = await this.getHoliday();
                console.log('휴가조회', data);
                this.holidays = data;
            } catch (error) {
                console.log(error);
                console.log('휴가를 조회할 수 없습니다.');
            }
        },
        // 휴가 조회 API
        getHoliday() {
            return api.get(
                `/admin/api/center/${this.loginCenterId}/staff/${
                    this.centerStaffId
                }/work-schedule/${this.selectedMonth.getFullYear()}/onlyHoliday`
            );
        },

        saveHoliday() {
            if (
                this.$moment(this.selectedHoliday.calenderStartDate).isAfter(
                    this.selectedHoliday.calenderEndDate,
                    'day'
                )
            ) {
                alert('날짜를 바르게 선택해주세요.');
                return;
            }
            if (this.selectedHoliday.hollydayFullYn) {
                this.selectedHoliday.startTime = '00:00:00';
                this.selectedHoliday.endTime = '00:00:00';
            }
            const data = eval(`(${JSON.stringify(this.selectedHoliday)})`);
            console.log(data);
            data.calenderStartDate = data.calenderStartDate.replace(/\-/g, '');
            data.calenderEndDate = data.calenderEndDate.replace(/\-/g, '');
            // data.startTime = data.startTime.replace(/:/g, '');
            // data.endTime = data.endTime.replace(/:/g, '');
            console.log(this.selectedHoliday.hollydayFullYn);
            api.post(
                `/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}/work-schedule/calendar`,
                {
                    calenderStartDate: data.calenderStartDate.replace(/\-/g, ''),
                    calenderEndDate: data.calenderEndDate.replace(/\-/g, ''),
                    hollydayType: 'C',
                    hollydayFullYn: this.selectedHoliday.hollydayFullYn,
                    startTime: data.startTime,
                    endTime: data.endTime,
                    memo: '',
                }
                // data
            )
                .then((res) => {
                    this.holidayPop = false;
                    this.loadHoliday();
                    alert('저장했습니다.');
                    this.load();
                })
                .catch((res) => {
                    this.isSaving = false;
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        addHoliday() {
            const max = Math.max(0, ...this.data.centerStaffCalendars.map((o) => o.index));
            this.selectedHoliday = {
                isNew: true,
                index: max + 1,
                centerId: this.loginCenterId,
                centerStaffId: this.centerStaffId,
                calenderStartDate: this.$moment().format('YYYY-MM-DD'),
                calenderEndDate: this.$moment().format('YYYY-MM-DD'),
                hollydayType: 'P',
                hollydayFullYn: false,
                startTime: '09:00:00',
                endTime: '18:00:00',
                memo: '',
            };
            this.holidayPop = true;
        },
        removeHoliday(item) {
            if (!confirm('삭제하시겠습니까?')) return;
            this.isSaving = true;
            api.delete(
                `/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}/work-schedule/calendar/${item.calenderDate}/detail/${item.centerStaffCalenderId}`
            )
                .then((res) => {
                    this.isSaving = false;
                    console.log('res', item);
                    // this.data.centerStaffCalendars.findIndex(o => o.index == item.index)
                    this.data.centerStaffCalendars.splice(
                        this.data.centerStaffCalendars.findIndex((o) => o.calenderDate == item.calenderDate),
                        1
                    );
                    // 삭제 후 재 조회
                    this.loadHoliday();
                })
                .catch((res) => {
                    this.isSaving = false;
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        editHoliday(item) {
            if (!this.isEditing) return;
            this.selectedHoliday = eval(`(${JSON.stringify(item)})`);
            this.selectedHoliday.calenderStartDate = item.calenderDate;
            this.selectedHoliday.calenderEndDate = item.calenderDate;
            this.holidayPop = true;
        },
        dateClass(ymd, date) {
            if (this.data.centerStaffCalendars.findIndex((o) => this.$moment(o.calenderDate).isSame(ymd, 'day')) > -1) {
                return 'active-round';
            }
            return '';
        },
        save() {
            const data = eval(`(${JSON.stringify(this.data)})`);
            console.log('값', data);
            // data.centerId = this.loginCenterId;
            // data.centerStaffId = this.centerStaffId;
            delete data.isNew;
            delete data.centerId;
            delete data.centerStaffId;
            delete data.centerStaffCalendars;
            for (let i = 1; i < 8; i++) {
                if (data[`week${i}RestStartTime`] == '') {
                    delete data[`week${i}RestStartTime`];
                    delete data[`week${i}RestEndTime`];
                }
            }
            this.isSaving = true;
            (this.data.isNew ? api.post : api.put)(
                `/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}/work-schedule`,
                data
            )
                .then((res) => {
                    this.isSaving = false;
                    alert('저장했습니다.');
                })
                .catch((res) => {
                    this.isSaving = false;
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        // 휴식시간 없음
        noRestTime(index) {
            this.data[`week${index + 1}RestStartTime`] = null;
            this.data[`week${index + 1}RestEndTime`] = null;
        },
        // 직원 정보 fetch
        async fetchCenterStaffDetail() {
            try {
                this.isLoading = true;
                const { data } = await this.sendGetCenterStaffDetail(this.centerStaffId);

                this.employeeInfo = { ...data };

                const { employeeInfo, staffTopInfo } = this;

                // let { name, nickName, memo, birthday, color, scheduleShowYn, reserveShowYn, phoneShowYn, emailShowYn, certShowYn, phone} = this.editField;
                this.defaultImageUrl = this.employeeInfo.imageUrl; // 사진
                this.colorCodeData = data.color;
                this.curSelectedRole = String(employeeInfo.roleId);

                // 상단에 노출되는 직원 카드
                staffTopInfo.name = employeeInfo.name;
                staffTopInfo.phone = employeeInfo.phone;

                if (employeeInfo.centerStaffRole) {
                    staffTopInfo.roleName = employeeInfo.centerStaffRole.roleName;
                } else {
                    staffTopInfo.roleName = '-';
                }

                if (employeeInfo.centerStaffTeams.length == 1) {
                    staffTopInfo.staffTeams = employeeInfo.centerStaffTeams[0].centerTeam.name;
                } else if (employeeInfo.centerStaffTeams.length == 0) {
                    staffTopInfo.staffTeams = '-';
                } else {
                    staffTopInfo.staffTeams = `${employeeInfo.centerStaffTeams[0].centerTeam.name} 외 ${
                        employeeInfo.centerStaffTeams.length - 1
                    }`;
                }

                if (employeeInfo.centerStaffTeams.length > 0) {
                    employeeInfo.centerStaffTeams.forEach((s) => {
                        const temp = {
                            centerTeamId: s.centerTeam.centerTeamId,
                            centerTeamName: s.centerTeam.name,
                        };
                        // editField.staffTeams.push(temp);
                    });
                }

                this.isLoading = false;

                console.log('===> Loading staff detail Successfully : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        // staff image 없을 경우 default image 표시
        imageUrlAlt(event) {
            event.target.src = '/img/temp/no_photo.jpg';
        },
        // 센터 직원 상세 조회 API
        sendGetCenterStaffDetail(centerStaffId) {
            return api.get(`/admin/api/center/${this.loginCenterId}/staff/${centerStaffId}`);
        },
        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}` });
        },
    },
};
</script>
<style lang="scss"></style>
